<template>
  <div>
    <div class="action-tabs" :class="{ 'is-closed': !isOpen }">
      <div class="action-header">
        <b-button
          v-if="isOpen"
          class="close-badge"
          size="is-small"
          type="is-text"
          @click="cancel">
          <span class="icon">
            <i class="fas fa-times"></i>
          </span>
        </b-button>
        <b-button
          class="is-info"
          :icon-left="isOpen ? 'tasks' : 'plus'"
          :class="{'action-tab': isOpen}"
          @click="toggle"
          :disabled="isOpen">
          <span v-if="!isOpen">Takip Yarat</span>
          <span v-else>Aksiyon Takip</span>
        </b-button>
      </div>
    </div>

    <b-collapse :open="isOpen" aria-id="actionForm">
      <form class="box action-form" v-on:submit.prevent="onSubmit()">
        <b-field label="Aksiyon Tanımı" :type="{ 'is-danger': errors.has('actionTitle') }" :message="errors.first('actionTitle')">
          <b-input
            v-model="value.actionTitle"
            maxlength="20"
            v-validate="'required'"
            name="actionTitle"
            placeholder="Maksimum 20 karakter olacak şekilde bir takip başlığı tanımlayın">
          </b-input>
        </b-field>

        <b-field label="Açıklama">
          <b-input
            v-model="value.answerDescription"
            type="textarea"
            rows="3"
            :placeholder="$t('description.processQuestionActionDescriptionPlaceholder')"
            expanded>
          </b-input>
        </b-field>

        <b-field label="Atanan Kişi" :type="{ 'is-danger': errors.has('actionAssignors') }" :message="errors.first('actionAssignors')">
          <b-input
            v-model="value.actionAssignors"
            name="actionAssignors"
            v-validate="'required'"
            placeholder="Kontrolün hayata geçmesinden mesul kişi veya kişiler (E-mail adresleri veya sadece isimleri, virgül veya noktalı virgül ile ayırınız)">
          </b-input>
        </b-field>

        <b-field label="Aksiyon Teslim Tarihi" :type="{ 'is-danger': errors.has('actionDeliveryDate') }" :message="errors.first('actionDeliveryDate')">
          <b-datepicker
            v-model="value.actionDeliveryDate"
            placeholder="Aksiyonun çalışır olarak teslim edileceği tarih"
            icon="calendar"
            v-validate="'required'"
            name="actionDeliveryDate"
            :month-names="dateSettings.monthNames"
            :day-names="dateSettings.dayNames"
            :first-day-of-week="dateSettings.firstDayOfWeek"
            :mobile-native="false"
            :min-date="new Date()"
            locale="en-GB"
            >
          </b-datepicker>
        </b-field>

        <div class="is-flex is-justify-content-space-between is-align-items-center mt-4">
          <b-button
            class="is-light"
            icon-left="times"
            @click="cancel">
            Sil
          </b-button>

          <div class="has-text-grey is-size-7" style="align-self: center; margin-left:4px;">
            Soruyu cevapladığınızda aksiyon bilgileri de kaydedilecektir
          </div>
        </div>
      </form>
    </b-collapse>
  </div>
</template>

<script>
import dateSettings from '@/_helpers/date.config'

export default {
  name: 'ActionTrackingForm',
  props: {
    value: {
      type: Object,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dateSettings
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$emit('update:isOpen', this.hasAction())
        } else {
          this.$emit('update:isOpen', false)
        }
      }
    }
  },
  methods: {
    cancel() {
      if (this.hasAction()) {
        this.$buefy.dialog.confirm({
          title: 'Dikkat',
          message: 'Aksiyon için girilen tüm bilgiler silinecektir. Devam etmek istiyor musunuz?',
          confirmText: 'Evet, Sil',
          cancelText: 'Hayır',
          type: 'is-warning',
          hasIcon: true,
          onConfirm: () => {
            this.$emit('input', {
              ...this.value,
              actionTitle: '',
              actionAssignors: '',
              actionDeliveryDate: null,
              answerDescription: ''
            })
            this.$emit('update:isOpen', false)
          }
        })
      } else {
        this.$emit('update:isOpen', false)
      }
    },
    async submit() {
      const result = await this.$validator.validateAll()
      return result
    },
    toggle() {
      this.$emit('update:isOpen', !this.isOpen)
    },
    hasAction() {
      return !!(this.value.actionTitle ||
                this.value.actionAssignors ||
                this.value.actionDeliveryDate)
    }
  }
}
</script>

<style scoped>
.action-tab {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  margin-bottom: -1px;
  z-index: 1;
}

.action-form {
  background-color: #f6f9fe;
  border: 1px solid #3273dc;
  margin-top: 0;
}

.action-tab[disabled] {
  background-color: #3273dc !important;
  border-color: #3273dc !important;
  color: white !important;
  opacity: 1 !important;
}

/* Bulma 0.7.5 has no mb-* helpers, so the space below the closed button is set here. With
   the form open the tab has to stay attached to the form below it */
.action-tabs.is-closed {
  margin-bottom: 0.75rem;
}

.action-header {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.close-badge {
  position: absolute;
  right: -8px;
  top: -8px;
  padding: 0;
  height: 18px;
  width: 18px;
  border-radius: 50%;
  background-color: #f5f5f5;
  color: #666;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dbdbdb;
  box-shadow: 0 1px 2px rgba(0,0,0,0.1);
}

.close-badge:hover {
  background-color: #eeeeee;
  color: #333;
}

.close-badge .icon {
  font-size: 0.75rem;
}
</style>
